import { Empty, UploadFile } from "antd";
import Title from "antd/es/typography/Title";
import React, { useMemo } from "react";
import { AdditionalFilePreview } from "./additional-file-preview";
import { FileInfo } from "../../../../../../generated";
import { FileUploadButton } from "../../../../../shared/file-upload/file-upload-button";
import { AuthResult, AzureBlobResponse } from "../../../../../shared/file-upload/azure-upload";

const ADDITIONAL_FILES_DIRECTORY_SLUG = "/additional-private-files/";

interface AdditionalFilesProps {
  onAuthorizeUploadRequest: (file: File) => Promise<AuthResult>;
  onSuccessfulUpload: (response: AzureBlobResponse, file?: UploadFile) => Promise<void>;
  files: FileInfo[];
  onDelete: (file: string) => void;
  caseState?: string;
  isCurrentAssigned: boolean;
  isUploadProcessing: boolean;
  disabled?: boolean;
}

export const AdditionalFiles: React.FC<AdditionalFilesProps> = (props) => {
  const filteredFiles = useMemo(() => {
    return props.files.filter((f) => f.name.includes(ADDITIONAL_FILES_DIRECTORY_SLUG));
  }, [props.files]);

  return (
    <div className="flex flex-col space-y-6">
      <div className="flex w-full justify-between">
        <div className="flex space-x-6 mr-4 mt-4">
          <Title level={5}>Additional Private Files</Title>
          <p>(Max 8 files - PDF, JPEG or PNG)</p>
        </div>
        <FileUploadButton
          buttonText="Add New File"
          authorizeRequest={props.onAuthorizeUploadRequest}
          maxFileCount={1}
          permittedContentTypes={["application/pdf", "image/jpeg", "image/png"]}
          permittedExtensions={["pdf", "jpeg", "jpg", "png"]}
          maxFileSizeBytes={10 * 1024 * 1024} // 10MB,
          maxWidthOrHeight={2048}
          onSuccess={props.onSuccessfulUpload}
          caseState={props.caseState ?? ""}
          isCurrentAssigned={props.isCurrentAssigned}
          isUploadPreviewImage={false}
          isDisabled={filteredFiles.length >= 8}
          isProcessing={props.isUploadProcessing}
        />
      </div>
      <div className="flex flex-col space-y-4">
        {filteredFiles.length > 0 ? (
          filteredFiles.map((file) => <AdditionalFilePreview key={file.name} fileName={file.name} fileUrl={file.url} onDelete={props.onDelete} disabled={props.disabled}/>)
        ) : (
          <Empty description="No additional files found." />
        )}
      </div>
    </div>
  );
};
